// extracted by mini-css-extract-plugin
module.exports = {"label":"vj","radioIcon":"vk","checked":"vl","inversedColors":"vm","radio":"vn","text":"vo"};